import { dialerAPI } from './api/DialerApi'
import { onboardingAPI } from './api/onboarding/OnboardingAPI'

class InitializationServiceDialer {
  public init = async () => {
    await dialerAPI.addListeners()
    await onboardingAPI.addListeners()
  }
}

export default new InitializationServiceDialer()
